import React, { useContext } from 'react';
import LocaleContext from 'constants/localization';
import { isVideoType } from '../../../helpers/mediaHelpers';

// Conditional action links for objects based on props
const ResultLinks = ({noLinks, object, displayLink, addToCart, removeFromCart, addLink, isPublicUser}) => {
  const LS = useContext(LocaleContext);

  if (noLinks) {
    return null;
  }

  let previewURL = `displayContent.do?uri=${object.image}&type=big`;
  if(object.image && isVideoType(object.image)){
    previewURL = `displayContent.do?uri=${object.image}`;
  }

  return (
    <div className="result-pane__links">
      { 
        addLink && 
          <ResultLink handleClick={() => addLink(object)} 
            iconClass="fa fa-paperclip" value={LS.actions.link} />
      }
      {
        displayLink &&
        <ResultLink href={`${displayLink(object.uri)}&windowId=` + sessionStorage.getItem("WINDOW_ID")}
          // Target is blank when linking objects to open in new tab
          target={addLink && '__blank'} iconClass="fa fa-sign-in" value={LS.actions.open} />
      }
      {
        removeFromCart && !isPublicUser && 
        <ResultLink handleClick={() => removeFromCart(object)} 
          iconClass="fa fa-minus" value={LS.actions.removeFromCart} />
      }
      {
        !addLink && addToCart && !isPublicUser && 
        <ResultLink handleClick={() => addToCart(object)} 
          iconClass="fa fa-cart-plus" value={LS.actions.addToCart} />
      }
      {
        object.image && 
          <ResultLink href={previewURL} 
            target="__blank" iconClass="fa fa-eye" value={LS.actions.preview} />
      }
    </div>
  );
};

export const ResultLink = ({ target, handleClick, iconClass, href, value }) => (
  <div className="dam-lisaa-lataa">
    <a target={target} tabIndex={0} onKeyDown={e => e.key === 'Enter' && handleClick()}
      href={href} className="action-link" onClick={handleClick}>
      <i className={iconClass}></i> {value}
    </a>
  </div>
);

export default ResultLinks;